export enum UserRole {
  ADMIN = 'admin',
  USER = 'user',
  EMPLOYEE = 'employee'
}

export enum UserStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export enum PermissionType {
  WEB = 'web',
  MINIPROGRAM = 'miniprogram'
}

export interface Permission {
  id: number;
  type: PermissionType | string;
  code: string;
  name: string;
  description?: string;
  isEnabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Role {
  id: number;
  name: string;
  description?: string;
  canAccessWeb: boolean;
  canAccessMiniprogram: boolean;
  canAccessEmployeeSpace: boolean;
  isActive: boolean;
  permissions: Permission[];
  createdAt: string;
  updatedAt: string;
}

export interface User {
  id: number;
  username: string;
  role: UserRole;
  status: UserStatus;
  validFrom: string;
  validTo: string;
  isSuperAdmin?: boolean;
  roles: Role[];
  permissions: Permission[];
  employee?: any;
  isEmployee?: boolean;
  canAccessEmployeeSpace?: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  user: User;
}

export interface UserState {
  isAuthenticated: boolean;
  user: User | null;
  token: string | null;
}

export interface UserPermissionsResponse {
  canAccessWeb: boolean;
  canAccessMiniprogram: boolean;
  permissions: Permission[];
  roles?: Role[];
}

export const WEB_MODULES = [
  { code: 'home', name: '首页' },
  { code: 'customers', name: '客户管理' },
  { code: 'products', name: '产品列表' },
  { code: 'product_categories', name: '产品分类' },
  { code: 'components', name: '组件列表' },
  { code: 'component_categories', name: '组件分类管理' },
  { code: 'component_specifications', name: '组件规格管理' },
  { code: 'orders', name: '订单列表' },
  { code: 'order_status', name: '订单状态管理' },
  { code: 'production', name: '生产安排' },
  { code: 'component_inventory', name: '组件库存' },
  { code: 'warehouse', name: '仓库管理' },
  { code: 'component_codes', name: '组件码管理' },
  { code: 'inventory_logs', name: '库存明细' },
  { code: 'shipments', name: '发货统计' },
  { code: 'return-orders', name: '退货管理' },
  { code: 'stocktakings', name: '盘点管理' },
  { code: 'transfer-orders', name: '调拨管理' },
  { code: 'users', name: '用户管理' },
  { code: 'roles', name: '角色管理' },
  { code: 'job_types', name: '工种管理' },
  { code: 'employees', name: '员工管理' },
  { code: 'enterprise_info', name: '企业信息' },
  { code: 'operation_logs', name: '操作日志' },
  { code: 'recycle_bin', name: '回收站' },
  { code: 'database_initialize', name: '数据库初始化' },
];
